import { GroupType, Permission, UserGroupType } from "../enums";

export interface IFolderNodePermission {
    code: string;
    level: Permission;
    type: GroupType;
    groupType: UserGroupType; //OR CompanyGroupType
}

export class FolderNodePermission implements IFolderNodePermission {
    code: string;
    level: Permission;
    type: GroupType;
    groupType: UserGroupType; //OR CompanyGroupType

    constructor();
    constructor(obj: IFolderNodePermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || Permission.None;
        this.type = obj && obj.type || GroupType.None;
        this.groupType = obj && obj.groupType || UserGroupType.Normal;
    }
}

export interface IFolderNodeSavePermission {
    code: string;
    level: Permission;
    type: GroupType;
}

export class FolderNodeSavePermission implements IFolderNodeSavePermission {
    code: string;
    level: Permission;
    type: GroupType;

    constructor();
    constructor(obj: IFolderNodeSavePermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || Permission.None;
        this.type = obj && obj.type || GroupType.None;
    }
}